import * as React from 'react';
import { ToggleView, ToggleViewProps } from './Toggle.view';
import { useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';

export type ToggleAction = (newVal: boolean, complete: (keepNewVal?: boolean) => void) => void;

export type ToggleControllerProps = Omit<ToggleViewProps, 'toggleHandler'> & {
  // extend your ToggleViewProps
  action?: ToggleAction;
};

export const ToggleController = (props: ToggleControllerProps): JSX.Element => {
  // Put All your methods and logic here
  const viewProps: ToggleControllerProps = { ...props };
  const defaultFormValueChecked = props.formInstance.formState.defaultValues?.[props.name] === 'true';
  const initialCheckedState = props.checked !== undefined ? props.checked : defaultFormValueChecked;
  const [checked, setChecked] = useState<boolean>(initialCheckedState);
  const [executing, setExecuting] = useState<boolean>(false);

  viewProps.disabled = props.disabled || executing || false;
  viewProps.helper = props.helper || '';

  const toggleHandler = (current: unknown) => {
    setChecked(old => {
      if (current === old) {
        return !old;
      }
      return old;
    });

    if (props.action) {
      setExecuting(true);
      props.action(!checked, (keepNewVal = true) => {
        setExecuting(false);
        if (!keepNewVal) {
          setChecked(checked);
        }
      });
    }
  };

  const formValue = useWatch({
    control: props.formInstance.control,
    name: props.name
  });

  // If the form value gets updated, update the internal state.
  useEffect(() => {
    if (formValue === 'true' || formValue === 'false') {
      setChecked(formValue === 'true');
    }
  }, [formValue]);

  // Added to address issues of re-rendering toggle with differing toggle values
  useEffect(() => {
    if (props.checked !== undefined) {
      setChecked(props.checked);
    }
  }, [props.checked]);

  const attrs = {
    ...viewProps,
    checked,
    toggleHandler
  };

  return <ToggleView {...attrs} />;
};
